import styled from "styled-components";
import { defaultTheme } from "styles/theme/default";

export const Nav = styled.nav`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  background: ${defaultTheme.colors["white-100"]};
  border-top: 1px solid ${defaultTheme.colors["white-box"]};
  padding-bottom: env(safe-area-inset-bottom, 0);

  @media screen and (min-width: 821px) {
    display: none;
  }
`;

export const NavItem = styled.a`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-height: 56px;
  padding: 6px 0;
  color: ${defaultTheme.colors["gray-200"]};
  text-decoration: none;
  font-family: ${defaultTheme.fonts.regular};
  font-size: 0.7rem;

  &.selected {
    color: ${defaultTheme.colors["base-dark"]};
  }
`;